import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import esUY from './locales/es-UY/common.json'

export const DEFAULT_LOCALE = 'es-UY'

export const SUPPORTED_LOCALES = ['es-UY'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

// init() is async, but resources are bundled synchronously so the first render
// resolves keys correctly. Revisit when locales become dynamic-loaded.
void i18n.use(initReactI18next).init({
  resources: {
    'es-UY': { common: esUY },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
